import { TabsContainer } from '@/components/TabView/Tabs';
import { useLocation } from 'react-router-dom';

type Props = {
  paths?: {
    tracker: string;
    projects: string;
    files: string;
  };
};

export const BrandTabView = ({
  paths = {
    tracker: `tracker`,
    projects: `projects`,
    files: `files`,
  },
}: Props) => {

  const location = useLocation();

  const current = [
    paths.files,
    paths.projects,
    paths.tracker,
  ].find(tab => location.pathname.endsWith(`/${tab}`)) || 'tracker';

  const items = [
    {
      label: 'Project Tracker',
      value: paths.tracker,
      to: 'tracker',
    },
    {
      label: 'Projects',
      value: paths.projects,
      to: 'projects',
    },
    {
      label: 'Files',
      value: paths.files,
      to: 'files',
    },
  ];

  return (
    <TabsContainer currentTab={current} items={items} />
  );
};

BrandTabView.displayName = 'Workspace.Brand.TabView';